import { LargeArrow, SmallArrow } from 'components/icons/Arrow'
import { cx } from 'lib/cx'
import React from 'react'

export type ArrowLinkProps = {
  children: React.ReactNode
  direction?: 'left' | 'right'
}

export function ArrowLink({ direction = 'right', children }: ArrowLinkProps) {
  return (
    <span
      className={cx(
        'inline-grid group grid-flow-col justify-start text-12 font-bold tracking-42 gap-16 transition-all',
        direction === 'left' ? '' : 'pr-8 hover:pr-0',
      )}
    >
      {direction === 'left' && (
        <span className="relative">
          <span className="inline-block transition-transform group-hover:translate-x-8">
            <SmallArrow className="rotate-180" />
          </span>
        </span>
      )}
      <span className="uppercase">{children}</span>
      {direction === 'right' && (
        <span>
          <SmallArrow />
        </span>
      )}
    </span>
  )
}

export function TitleArrowLink({ children }: ArrowLinkProps) {
  return (
    <span className="group grid grid-flow-col justify-start items-center gap-32 pl-0 pr-8 transition-all hover:pl-8 hover:pr-0">
      <span className="h2">{children}</span>
      <span className="opacity-0 group-hover:opacity-100">
        <LargeArrow />
      </span>
    </span>
  )
}
